/**
 * Tailwind classes for rendered markdown (headings, lists, links, tables).
 * Matches prose usage elsewhere in the storefront.
 */
export const MARKDOWN_PROSE_CLASS =
    'prose prose-sm max-w-none text-foreground [&_a]:text-primary [&_a]:underline-offset-4 hover:[&_a]:underline';
